var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6041 53.1885L43.6753 10.0218C42.9988 8.85007 42.0257 7.87708 40.8539 7.20059C39.6821 6.52411 38.353 6.16797 36.9999 6.16797C35.6469 6.16797 34.3177 6.52411 33.1459 7.20059C31.9742 7.87708 31.0011 8.85007 30.3245 10.0218L5.39576 53.1885C4.71896 54.3607 4.36278 55.6905 4.36304 57.0441C4.3633 58.3977 4.72 59.7274 5.39725 60.8994C6.07451 62.0714 7.04844 63.0444 8.22108 63.7205C9.39373 64.3966 10.7237 64.752 12.0773 64.751H61.9225C63.2756 64.7509 64.6048 64.3947 65.7766 63.7182C66.9484 63.0416 67.9214 62.0685 68.598 60.8967C69.2745 59.7249 69.6307 58.3957 69.6306 57.0426C69.6306 55.6895 69.2745 54.3603 68.5979 53.1885H68.6041Z",
    fill: "url(#paint0_linear_30497_5288)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 46.2494C37.8079 46.253 38.5879 45.9546 39.1869 45.4126C39.7859 44.8706 40.1607 44.1243 40.2376 43.3202L42.0568 25.1285C42.1215 24.4847 42.0504 23.8345 41.8481 23.22C41.6458 22.6054 41.3168 22.0401 40.8824 21.5606C40.4479 21.0811 39.9177 20.6981 39.326 20.4364C38.7343 20.1746 38.0942 20.0399 37.4472 20.041H36.553C35.9067 20.041 35.2675 20.1765 34.6767 20.4387C34.0859 20.7009 33.5566 21.0841 33.123 21.5635C32.6894 22.0428 32.3611 22.6077 32.1593 23.2218C31.9574 23.8358 31.8865 24.4854 31.9512 25.1285L33.7703 43.3202C33.8471 44.123 34.2208 44.8682 34.8182 45.41C35.4156 45.9518 36.1937 46.2511 37.0001 46.2494Z",
    fill: "url(#paint1_linear_30497_5288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 58.5827C39.9801 58.5827 42.3959 56.1669 42.3959 53.1868C42.3959 50.2068 39.9801 47.791 37.0001 47.791C34.02 47.791 31.6042 50.2068 31.6042 53.1868C31.6042 56.1669 34.02 58.5827 37.0001 58.5827Z",
    fill: "url(#paint2_linear_30497_5288)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30497_5288",
    x1: 18.7065,
    y1: 31.3523,
    x2: 64.7915,
    y2: 63.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30497_5288",
    x1: 31.3237,
    y1: 24.0309,
    x2: 42.473,
    y2: 40.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30497_5288",
    x1: 33.576,
    y1: 49.7628,
    x2: 40.2006,
    y2: 56.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e6590c69838208444764d676bf4e5139.svg";
export { ForwardRef as ReactComponent };